import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  /* 首页部分路由，不需要登陆也可以查看*/
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'Index',
    component: () => import('@/views/index/index/index')
  },
  {
    path: '/index/about',
    component: () => import('@/views/index/about')
  },
  {
    path: '/index/recruit',
    component: () => import('@/views/index/recruit')
  },
  {
    path: '/index/news',
    component: () => import('@/views/index/news')
  },
  {
    path: '/index/newInfo',
    component: () => import('@/views/index/news/newInfo')
  },
  {
    path: '/index/gamePage/bxzl',
    component: () => import('@/views/gamePage/bxzl.vue')
  },
  {
    path: '/index/404',
    component: () => import('@/views/404.vue'),
    hidden: true
  },
  /* 因为匹配符是 * 所以必须在最后*/
  { path: '*', redirect: '/404', hidden: true }
]

// Vue 2 中创建路由实例的方式
const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

// 核心：拦截/index/并修正为/index
router.beforeEach((to, from, next) => {
  // 处理路径的核心逻辑
  const processPath = (path) => {
    // 空路径直接返回
    if (path === '/') return path

    // 连续斜杠处理为单斜杠
    let processed = path.replace(/\/+/g, '/')

    // 移除末尾斜杠（除了根路径）
    if (processed.length > 1 && processed.endsWith('/')) {
      processed = processed.slice(0, -1)
    }

    return processed
  }

  const normalizedPath = processPath(to.path)
  console.log(normalizedPath)

  // 如果处理后的路径与原路径不同，则重定向
  if (normalizedPath !== to.path) {
    return next({
      path: normalizedPath,
      hash: to.hash,
      query: to.query,
      replace: true // 替换历史记录，避免回退问题
    })
  }

  // 处理/index/的特殊情况
  if (to.path === '/index/') {
    return next({
      path: '/index',
      hash: to.hash,
      query: to.query,
      replace: true
    })
  }

  // 处理/index/*/的情况
  if (to.path === '/index/') {
    return next({
      path: '/index',
      hash: to.hash,
      query: to.query,
      replace: true
    })
  }

  next()
})

// 额外添加全局路由监听，确保导航后路径正确
router.afterEach((to) => {
  // 检查浏览器地址栏实际路径是否与预期一致
  const currentPath = window.location.pathname
  const expectedPath = to.path

  if (currentPath !== expectedPath) {
    // 强制修正地址栏显示
    window.history.replaceState(null, '', expectedPath + to.hash + (to.query ? new URLSearchParams(to.query).toString() : ''))
  }
})
export function resetRouter() {
  const newRouter = new Router({ // 同样用 new Router()
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })
  router.matcher = newRouter.matcher
}

export default router
